module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/aside_person-99c9d6f9b02b84b9aff9dce4ff4821cc.svg";